import { splice } from 'micromark-util-chunked';
import { tokenTypes } from './types.js';
const extendedTableCellConstruct = {
  name: 'extendedTableCell',
  tokenize: tokenizeExtendedTableCell,
  resolveAll: resolveAll
};
export const extendedTable = {
  text: {
    [94]: extendedTableCellConstruct,
    [62]: extendedTableCellConstruct
  }
};
function formatEvents(events) {
  if (events == null) {
    return;
  }
  return events.map(x => {
    let content = '';
    try {
      content = x[2].sliceSerialize(x[1], true);
    } catch (e) {
      content = '<maybe incomplete token>';
    }
    return [x[0], x[1].type, content];
  });
}
function resolveAll(events, context) {
  // remove span marker if cell contains any other elements
  if (events.length >= 3) {
    const tokenType = events[0][1].type;
    if (events[2][1].type === "data") {
      events[2][1].start = Object.assign({}, events[0][1].start);
      splice(events, 0, 2, []);
    } else {
      events[0][1].type = "data";
      events[1][1].type = "data";
    }
  }
  return events;
}
function tokenizeExtendedTableCell(effects, ok, nok) {
  const self = this; // eslint-disable-line @typescript-eslint/no-this-alias
  // expect the start in a cell
  if (self.events.length !== 0) {
    return nok;
  }
  return start;
  function start(code) {
    switch (code) {
      case 94:
        effects.enter(tokenTypes.extendedTableCellRowspanMarker);
        effects.consume(code);
        effects.exit(tokenTypes.extendedTableCellRowspanMarker);
        break;
      case 62:
        effects.enter(tokenTypes.extendedTableCellColspanMarker);
        effects.consume(code);
        effects.exit(tokenTypes.extendedTableCellColspanMarker);
        break;
      default:
        return nok(code);
    }
    return ok;
  }
}